/**
 * Constants with no Zod dependency.
 *
 * This module exists for one measured reason. `@lila/shared` is a barrel, and the SPA
 * imports two values from it on every page load: `ErrorCode`, and `LOCALES` for the locale
 * router guard. `LOCALES` used to live in `schemas/primitives.ts` beside `localeSchema`,
 * which is the natural place for it and which imports Zod — so importing a four-element
 * string array put 265 KB of validation library into the landing page's initial bundle.
 *
 * Rollup cannot tree-shake it away: `z.object(...)` at module scope is a call expression,
 * and a bundler must assume a call can throw. `sideEffects: false` lets it drop unused
 * MODULES, which is exactly what this file makes possible — `primitives.ts` is now
 * unreachable from a client that only wants the locale list.
 *
 * The rule that follows: anything the client needs at BOOT belongs here, next to nothing.
 */
/** Spec 2.3: ru, uk, de, en. "No RTL languages planned." */
export const LOCALES = ['ru', 'uk', 'de', 'en'];
//# sourceMappingURL=constants.js.map